import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
import slick from 'slick-carousel';


/* https://codepen.io/jamesjo29155352/pen/NWjOrrx */

$(document).ready(function(){
	

	$(".hero-slider").slick({	
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
	});

	//ticking machine
	var percentTime;
	var tick;
	var time = 1;
	var progressBarIndex = 0;

	$('.progressbar-container .progressbar').each(function(index) {
	    var progress = "<div class='inProgress inProgress" + index + "'></div>";
	    $(this).html(progress);
	});

	function startProgressbar() {
	    resetProgressbar();
	    percentTime = 0;
	    tick = setInterval(interval, 12); /* <<<<< SET LENGTH HERE <<<<< */
	}

	function interval() {
	    if (($('.slider .slick-track div[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
	        progressBarIndex = $('.slider .slick-track div[aria-hidden="false"]').data("slickIndex");
	        startProgressbar();
	    } else {
	        percentTime += 1 / (time + 5);
        $('.inProgress').parent().parent().removeClass("active");
        $('.inProgress' + progressBarIndex).parent().parent().addClass("active");
	        $('.inProgress' + progressBarIndex).css({
	            width: percentTime + "%"
	        });
	        if (percentTime >= 100) {
	            $('.single-item').slick('slickNext');
	            progressBarIndex++;
	            if (progressBarIndex > 2) {
	                progressBarIndex = 0;
	            }
	            startProgressbar();
	        }
	    }
	}

	function resetProgressbar() {
	    $('.inProgress').css({
	        width: 0 + '%'
	    });
	    clearInterval(tick);
	}
	startProgressbar();
	// End ticking machine

	$('.progressbar-container div').click(function () {
		clearInterval(tick);
		var goToThisIndex = $(this).find("span").data("slickIndex");
		$('.single-item').slick('slickGoTo', goToThisIndex, false);
		startProgressbar();
	});
	


	// video/viewport ratio checker
	function enable_ratiochecker (){

		function check_16by9(){
			let videos = document.getElementsByClassName ("hero-video");
			let numvideos = videos.length;
	
			for (let i=0; i<numvideos; i++) {
				if((videos[i].offsetWidth / videos[i].offsetHeight) >= (16/9)){
					videos[i].classList.add("ratio16by9");
				} else {
					videos[i].classList.remove("ratio16by9");
				}
			}
		}
	
		window.addEventListener('resize', function(event) {
			check_16by9();
		}, true);
	
		check_16by9();
	
	};
	
	if (document.getElementsByClassName("hero-video").length > 0) {
		enable_ratiochecker();
	}

		
});












